import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center border border-dotted mb-8" }
const _hoisted_2 = { class: "flex-grow-1" }
const _hoisted_3 = { class: "text-gray-800 text-hover-primary fw-bolder fs-6 cursor-pointer" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-bold d-block" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: _normalizeClass(["bullet bullet-vertical h-40px me-4", `bg-${_ctx.color}`])
    }, null, 2),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.text), 1),
      _hoisted_4
    ])
  ]))
}